import palette from '@/theme/palette.ts';

export const styles = {
  editProductFormContainer: {
    maxWidth: '1000px',
    paddingTop: 0,
    '& .MuiInputBase-root': {
      backgroundColor: palette.surface.white,
    },
  },
};
